export default function IconMinus(props) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" {...props}>
      <line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  )
}
